export default "__VITE_ASSET__c1169bf8__"